var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaserSwap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.78332 24.9432L2.23665 23.4565L0.213319 22.9132C-0.119884 20.6457 -0.0623866 18.3379 0.383319 16.0898L1.99999 18.0332L7.78332 24.9432Z",
    fill: "#20E0B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15664 28.5997L4.78664 32.9664C3.14218 31.0422 1.87659 28.8243 1.05664 26.4297L3.33331 27.033L9.15664 28.5997Z",
    fill: "#03DAC5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5701 38.9437C11.1755 38.1237 8.95759 36.8581 7.03345 35.2137L8.36678 33.8804L11.3868 30.8604L12.9634 36.667L13.5701 38.9437Z",
    fill: "#03DAC5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9066 39.6168C21.6597 40.0625 19.353 40.12 17.0866 39.7868L16.5433 37.7635L15.0566 32.2168L21.9666 38.0001L23.9066 39.6168Z",
    fill: "#20E0B7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1767 35.0333C31.5086 36.501 29.6068 37.6795 27.55 38.5199L25.8833 37.1166L18.76 31.1699L30.9067 34.4266L33.1767 35.0333Z",
    fill: "#3DE6AA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9267 26.4697C38.1865 28.6231 37.084 30.6342 35.6667 32.4164L33.6401 31.8731L20.8301 28.4364L36.8101 26.6997L38.9267 26.4697Z",
    fill: "#5AED9C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 20.0001C40.0011 21.0675 39.9153 22.1332 39.7434 23.1867L37.7734 23.4034L21.1467 25.2101L37.8601 17.1001L39.6401 16.2334C39.8805 17.4745 40.0011 18.7359 40.0001 20.0001Z",
    fill: "#94F981"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7799 13.1198L37.0566 13.9565L20.0166 22.2298L33.8633 8.38314L35.2166 7.0498C36.7535 8.84682 37.9599 10.9019 38.7799 13.1198Z",
    fill: "#B1FF73"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9667 4.78306L31.6167 6.13639L17.77 19.9797L26.0434 2.94306L26.88 1.21973C29.1038 2.03794 31.1647 3.24444 32.9667 4.78306Z",
    fill: "#B1FF73"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7667 0.360002L22.9 2.14L14.79 18.85L16.5967 2.22667L16.8134 0.256669C19.1192 -0.117339 21.473 -0.0823602 23.7667 0.360002Z",
    fill: "#94F981"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5299 1.07324L13.2999 3.18991L11.5633 19.1699L8.12659 6.35658L7.58325 4.33324C9.36544 2.91598 11.3766 1.81347 13.5299 1.07324Z",
    fill: "#5AED9C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82998 21.2432L2.88331 14.1299L1.47998 12.4632C2.31912 10.4017 3.49765 8.49536 4.96665 6.82324L5.57331 9.09324L8.82998 21.2432Z",
    fill: "#3DE6AA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaserSwap);
export default __webpack_public_path__ + "static/media/laser-swap.ac4bb3c2.svg";
export { ForwardRef as ReactComponent };